import React, { FC } from 'react';
import styled from 'styled-components';

const TopGradient = styled.div<{ visible?: boolean; smallPlayer?: boolean }>`
  height: 60%;
  background-image: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.base.main} 0%,
    rgba(24, 27, 50, 0) 96.88%
  );
  opacity: ${({ visible }) => (visible ? 0.7 : 0)};
  transition: ${({ theme }) => theme.transition('opacity', 300)};
  ${({ theme, smallPlayer }) =>
    !smallPlayer
      ? `
        ${theme.breakpoints.up('md')} {
          height: 204px;
          background-image: linear-gradient(
            180deg,
            ${theme.colors.base.main} 0%,
            rgba(24, 27, 50, 0) 100%
          );
        }
      `
      : ''}
`;

const BottomGradient = styled.div<{ visible?: boolean; smallPlayer?: boolean }>`
  height: 60%;
  background-image: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.base.main} 0%,
    rgba(24, 27, 50, 0) 96.88%
  );
  transform: rotate(-180deg);
  opacity: ${({ visible }) => (visible ? 0.7 : 0)};
  transition: ${({ theme }) => theme.transition('opacity', 300)};
  ${({ theme, smallPlayer }) =>
    smallPlayer
      ? `
        ${theme.breakpoints.up('md')} {
          height: 204px;
          background-image: linear-gradient(
            180deg,
            ${theme.colors.base.main} 19.79%,
            rgba(24, 27, 50, 0) 87.5%
          );
        }
      `
      : ''}
`;

interface GradientProps {
  visibleUi?: boolean;
  smallPlayer?: boolean;
}

const Gradient: FC<GradientProps> = ({ visibleUi, smallPlayer }) => (
  <div
    className="cp-gradient absolute inset-0 z-1"
    style={{ mixBlendMode: 'multiply' }}
  >
    <TopGradient
      className="absolute top-0 left-0 w-full"
      visible={visibleUi}
      smallPlayer={smallPlayer}
    />
    <BottomGradient
      className="absolute bottom-0 left-0 w-full"
      visible={visibleUi}
      smallPlayer={smallPlayer}
    />
  </div>
);

export default Gradient;
